import { Button as MortarButton } from '@policygenius/mortar';

import { track } from 'analytics/frontend';

import { ButtonProps } from './types';

const Button: React.FC<ButtonProps> = ({ onClick, analyticsProps, ...props }) => {
  const _onClick: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    track('Clicked Button', analyticsProps);
    onClick?.(e);
  };

  return <MortarButton {...props} onClick={_onClick} />;
};

export default Button;
